import React from 'react'
import { Link } from 'react-router-dom'


const DonationArea = () => {
  return (
    <>
     <section id="donate_area">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 offset-lg-3">
                    <div className="donate_text">
                        <h3>Grow with PCF</h3>
                        <h2>
                            Culture, learning &amp; <span className="color_big_heading">integration</span> — strong on court and in society
                        </h2>
                        <Link to="/make-donation" className="btn btn_md btn_theme" style={{ display: "none" }}>Donate now</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>

    </>
  )
}

export default DonationArea